import { Building2, type LucideIcon } from 'lucide-react';

type SellerRowHeaderProps = {
  organizationLabel: string;
  subtitleIcon: LucideIcon;
  subtitle: string;
  subtitleId?: string;
};

export function SellerRowHeader({
  organizationLabel,
  subtitleIcon: SubtitleIcon,
  subtitle,
  subtitleId,
}: Readonly<SellerRowHeaderProps>) {
  return (
    <>
      <span
        aria-hidden="true"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-neut-100 text-neut-600"
      >
        <Building2 size={18} />
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="truncate text-sm font-semibold text-neut-prim">
          {organizationLabel}
        </span>
        <span
          id={subtitleId}
          className="flex items-center gap-1.5 text-xs text-neut-sec"
        >
          <SubtitleIcon size={12} aria-hidden="true" />
          {subtitle}
        </span>
      </span>
    </>
  );
}
